/**
 * 月次レポート一覧の検索モード (#4421)。
 *
 * `MONTH_RANGE` は既存の月単位の検索で、1 行が「取引先 × 計上月」になる。
 * `DATE_RANGE` は任意の日付範囲での再集計で、1 行が「取引先」になる。
 *
 * #4387 の `SearchDateBasis`（計上日基準か締日基準か）とは別の軸なので、
 * 名前の衝突を避けて別の型名にしている（設計書 §4.4）。
 */
export const REPORT_SEARCH_MODE = {
  MONTH_RANGE: 'MONTH_RANGE',
  DATE_RANGE: 'DATE_RANGE'
} as const

export type ReportSearchMode =
  (typeof REPORT_SEARCH_MODE)[keyof typeof REPORT_SEARCH_MODE]

export const isDateRangeMode = (mode: ReportSearchMode | undefined): boolean =>
  mode === REPORT_SEARCH_MODE.DATE_RANGE
